<app-top-nav-bar-button
	id="matter-nav-checklist"
	[icon]="'list-check'"
	[showPercentage]="true"
	title="Checklist"
	[num]="completePercentage$ | async"
	[testHook]="testHooks.MatterNavChecklistButton"
	(showing)="showChecklistDropdown = $event"
>
	<div class="dropdown p-6 w-[460px] max-h-[70vh] overflow-auto">
		<app-matter-checklist location="nav"></app-matter-checklist>
	</div>
</app-top-nav-bar-button>
